import { LazyRouteFunction, NonIndexRouteObject } from 'react-router-dom';

export type NavigationConfig = {
  path: string;
  lazy?: LazyRouteFunction<NonIndexRouteObject>;
};

export const employeeAuthenticatedNavigationConfig: NavigationConfig[] = [
  //employee routes
  {
    path: '/employee/notifications',
    lazy: async () => ({
      Component: (await import('../../../../pages/workersNotifications/WorkersNotificationsPage'))
        .default,
    }),
  },
  {
    path: '/employee/schedule',
    lazy: async () => ({
      Component: (await import('../../../../pages/workingSchedule/WorkingSchedulePage')).default,
    }),
  },
  {
    path: '/employee/schedule/details',
    lazy: async () => ({
      Component: (await import('../../../../pages/workingSchedule/WorkingScheduleDetails')).default,
    }),
  },
  {
    path: '/employee/schedule/details/contacts',
    lazy: async () => ({
      Component: (await import('../../../../pages/workingSchedule/WorkingScheduleDetailsContacts'))
        .default,
    }),
  },
  {
    path: '/employee/schedule/details/tasks',
    lazy: async () => ({
      Component: (await import('../../../../pages/workingSchedule/WorkingScheduleDetailsTasks'))
        .default,
    }),
  },
  {
    path: '/employee/schedule/details/delivered-articles',
    lazy: async () => ({
      Component: (
        await import(
          '../../../../pages/workingSchedule/WorkingScheduleDetailsDeliveredArticlesPage'
        )
      ).default,
    }),
  },
  {
    path: '/employee/schedule/details/report-missing-articles',
    lazy: async () => ({
      Component: (
        await import(
          '../../../../pages/workingSchedule/WorkingScheduleDetailsReportMissingArticlesPage'
        )
      ).default,
    }),
  },
  {
    path: '/employee/schedule/details/complete',
    lazy: async () => ({
      Component: (
        await import('../../../../pages/workingSchedule/WorkingScheduleDetailsCompletePage')
      ).default,
    }),
  },
  {
    path: '/employee/schedule/details/reported-missing-products',
    lazy: async () => ({
      Component: (
        await import(
          '../../../../pages/workingSchedule/WorkingScheduleDetailsReportedMissingProductsPage'
        )
      ).default,
    }),
  },
  {
    path: '/employee/schedule/details/check-reported-missing-products',
    lazy: async () => ({
      Component: (
        await import(
          '../../../../pages/workingSchedule/WorkingScheduleDetailsCheckReportedMissingProductsPage'
        )
      ).default,
    }),
  },
  {
    path: '/employee/packing-list',
    lazy: async () => ({
      Component: (await import('../../../../pages/workersPackingList/WorkersPackingListPage'))
        .default,
    }),
  },
  {
    path: '/employee/settings',
    lazy: async () => ({
      Component: (await import('../../../../pages/workersSettings/WorkersSettingsPage')).default,
    }),
  },
  {
    path: '/employee/absence',
    lazy: async () => ({
      Component: (await import('../../../../pages/workersAbsenceReporting/WorkersAbsencesPage'))
        .default,
    }),
  },
  {
    path: '/employee/absence/report',
    lazy: async () => ({
      Component: (
        await import('../../../../pages/workersAbsenceReporting/WorkersAbsenceReportingPage')
      ).default,
    }),
  },
];
